import { ref, computed, onMounted } from 'vue'
import { createSharedComposable } from '@vueuse/core'
import { getLookerDashboards } from '@/modules/dashboard/api'
import { getLookerDashboardByName } from '@/modules/dashboard/looker/utils/lookup'
import type { LookerDashboard } from '@/modules/dashboard/looker/types'

export const useDashboardsList = createSharedComposable(() => {
  const dashboardList = ref<LookerDashboard[]>([])
  const lookerRegionalInstance = ref()

  const lookerAutoQaDashboard = computed(() => getLookerDashboardByName(dashboardList.value, 'auto_qa'))
  const lookerReviewsDashboard = computed(() => getLookerDashboardByName(dashboardList.value, 'reviews'))
  const lookerReviewsAgentDashboard = computed(() => getLookerDashboardByName(dashboardList.value, 'reviews_agent'))
  const lookerBotQaDashboard = computed(() => getLookerDashboardByName(dashboardList.value, 'botqa'))
  const lookerAssignmentsDashboard = computed(() => getLookerDashboardByName(dashboardList.value, 'assignments'))
  const lookerCoachingDashboard = computed(() => getLookerDashboardByName(dashboardList.value, 'coaching'))
  const lookerSurveysDashboard = computed(
    () =>
      getLookerDashboardByName(dashboardList.value, 'surveys') ||
      getLookerDashboardByName(dashboardList.value, 'surveys_agent'),
  )
  const lookerCategoriesDashboard = computed(() => getLookerDashboardByName(dashboardList.value, 'categories'))
  const lookerCategoriesAgentDashboard = computed(() =>
    getLookerDashboardByName(dashboardList.value, 'categories_agent'),
  )
  const lookerCalibrationDashboard = computed(() => getLookerDashboardByName(dashboardList.value, 'calibration'))
  const lookerCalibrationAgentDashboard = computed(() =>
    getLookerDashboardByName(dashboardList.value, 'calibration_agent'),
  )
  const lookerCalibrationSubmitDashboard = computed(() =>
    getLookerDashboardByName(dashboardList.value, 'calibration_submit'),
  )

  const lookerDisputesDashboard = computed(() => getLookerDashboardByName(dashboardList.value, 'disputes'))
  const lookerDisputesAgentDashboard = computed(() => getLookerDashboardByName(dashboardList.value, 'disputes_agent'))

  const loadLookerDashboardsList = async () => {
    const { dashboards, lookerRegionalInstance: lookerInstance } = await getLookerDashboards()
    dashboardList.value = dashboards
    lookerRegionalInstance.value = lookerInstance
  }

  onMounted(() => {
    if (dashboardList.value.length) return
    loadLookerDashboardsList()
  })

  return {
    dashboardList,
    lookerAutoQaDashboard,
    lookerReviewsDashboard,
    lookerReviewsAgentDashboard,
    lookerBotQaDashboard,
    lookerAssignmentsDashboard,
    lookerSurveysDashboard,
    lookerCategoriesDashboard,
    lookerCategoriesAgentDashboard,
    lookerCalibrationDashboard,
    lookerCalibrationAgentDashboard,
    lookerCalibrationSubmitDashboard,
    lookerCoachingDashboard,
    lookerDisputesDashboard,
    lookerDisputesAgentDashboard,
    loadLookerDashboardsList,
    lookerRegionalInstance,
  }
})
